// extracted by mini-css-extract-plugin
export default {"root":"PaymentPage_root__Nc-VS","pagination":"PaymentPage_pagination__DM1pr"};